<div class="error-page">
  <div class="error-message fk-h1">
    {{ translate('title') }}
  </div>
  <div class="error-description fk-subtitle1">{{ translate('message') }}&nbsp;<span *ngIf="originURL">({{ originURL }})</span></div>
  <img [src]="logoPath" class="frog-illustration" />
</div>
